<template>
  <section>
    <b-breadcrumb :items="breadCrumbs" />

    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col md="3" class="my-1">
        <b-form-group horizontal label="Per page" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
      <b-col md="3" class="my-1">
        <b-btn
          variant="primary"
          size="md"
          class="float-right"
          :to="'/packages/add'"
          >Add Package</b-btn
        >
      </b-col>
    </b-row>

    <b-table
      show-empty
      v-if="items"
      stacked="md"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <template slot="cell(actions)" slot-scope="row">
        <b-btn
          class="ml-2"
          size="sm"
          variant="danger"
          @click="deleteConfirm(row.item.parent)"
          >Delete</b-btn
        >
      </template>
      <template slot="cell(ingredients)" slot-scope="row">
        <ul>
          <li v-for="(son, key) in row.item.sons" :key="key">
            {{ son.quantity + " X " + son.model }}
          </li>
        </ul>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
export default {
  name: "opencart-packages",
  components: {},
  mounted: function() {
    //get packages
    this.getPackages();
  },
  data() {
    return {
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Packages", active: true }
      ],
      fields: [
        {
          key: "parent",
          label: "Parent Model",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "ingredients",
          label: "Ingredients",
          sortable: true,
          sortDirection: "desc"
        },
        { key: "actions", label: "Actions", class: "text-center actions-col" }
      ],
      items: null,
      currentPage: 1,
      perPage: 50,
      totalRows: this.items ? this.items.length : 0,
      pageOptions: [25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null
    };
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getPackages() {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/packages").then(
        response => {
          this.items = response.data;
          loader.hide();
        },
        error => {
          console.log(error);
        }
      );
    },
    deleteConfirm(model) {
      this.$swal({
        title: "Are you sure?",
        text: "You want to delete package: " + model,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.deletePackage(model);
        }
      });
    },
    deletePackage(model) {
      let loader = this.$loading.show();
      this.$http.delete(this.APIURL + this.BRAND + "/packages/" + model).then(
        response => {
          this.$swal({
            title: "Success!",
            showConfirmButton: false,
            timer: 1000,
            html: "Package deleted successfully!",
            type: "success",
            onClose: () => {
              loader.hide();
              this.getPackages();
            }
          });
        },
        error => {
          console.log(error);
        }
      );
    }
  }
};
</script>
